import { Component, OnInit , Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MediaViewerComponent } from '../media-viewer/media-viewer.component';

@Component({
  selector: 'app-sf-gallery',
  templateUrl: './sf-gallery.component.html',
  styleUrls: ['./sf-gallery.component.css']
})
export class SfGalleryComponent implements OnInit {
  @Input() images: Array<string>;

  imageIndex: number;
  navPosition: number;
  groups: number;

  constructor(
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    this.imageIndex = 0;
    this.navPosition = 0;
    this.groups = Math.ceil(this.images.length / 4);
  }

  showImage(index: number) {
    this.imageIndex = index;
  }

  showImageDir(dir: string) {
    let index = 0;
    switch (dir) {
      case 'previous':
      index = this.imageIndex === 0 ? this.images.length - 1 : this.imageIndex - 1;
      this.navPosition = ((4 * 76) * this.calculateGroup(index)) * -1;
      break;
      case 'next':
      index = this.imageIndex === this.images.length - 1 ? 0 : this.imageIndex + 1;
      this.navPosition = ((4 * 76) * this.calculateGroup(index)) * -1;
      break;
    }
    this.imageIndex = index;
  }

  calculateGroup(index: number) {
    if (index >= 0 && index <= 3) {
      return 0;
    }else if (index >= 3 && index <= 7) {
      return 1;
    }else if (index >= 7 && index <= 11) {
      return 2;
    }else if (index >= 15 && index <= 19) {
      return 3;
    }else if (index >= 19 && index <= 23) {
      return 4;
    }else if (index >= 23 && index <= 27) {
      return 5;
    }else if (index >= 27 && index <= 31) {
      return 6;
    }
  }

  openMediaViewer() {
    const images = this.images.map((image: any, index: number) => {
      image.id = index;
      image.url = image.medium;
      image.esVideo = false;
      image.tipo = 'PROD_IMAGEN_GALERIA';
      return image;
    });
    const viewModal = this.modalService.open(MediaViewerComponent,  {size: 'lg', windowClass: 'media-viewer'});
    viewModal.componentInstance.items = images;
    viewModal.componentInstance.currentItem = this.imageIndex;
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/utils/sf-gallery/sf-gallery.component.ts